const breadcrumb = {
  reports: 'Reports',
  details: 'Report Details',
  unknown: 'Unknown',
};

const button = {
  backToList: 'Back to List',
  downloadReportKML: 'Download Report KML',
  downloadReportPDF: 'Download Report PDF',
  pdfReportTooltip: 'The maximum number of findings to generate a PDF is 500. Please apply more filters.',
  downloadErrorReportCSV: 'Download Error Report CSV',
  uploadReport: 'Upload Report',
  exportPatrols: 'Export patrols',
  filterPatrols: 'Filter patrols',
  startDate: 'Start date',
  endDate: 'End date',
  publish: 'Publish',
  pushToIRTH: 'Push to IRTH',
  resyncPilot: 'Resync Pilot',
};

const details = {
  airports: 'Airports',
  centerlines: 'Centerlines',
  coverage: 'Coverage',
  hyspexCoverage: 'Hyspex Coverage',
  endDate: 'End Date & Time',
  flightDuration: 'Flight Duration',
  flightPath: 'Flight Path',
  inspectionDuration: 'Inspection Duration',
  obstacles: 'Obstacles',
  pipelineCenterline: 'Pipeline Centerline',
  startDate: 'Start Date & Time',
  threat: 'Threat',
  threats: 'Threats',
  transferDate: 'Transfer Date & Time',
  uncoveredAreas: 'Uncovered Areas',
};

const table = {
  missionLength: 'Mission length (mi)',
  coverage: 'Coverage',
  detectedThreats: 'Detected Threats',
  downloadedBy: 'Downloaded By',
  flightDuration: 'Flight Duration',
  inspectionDuration: 'Inspection Duration',
  missionName: 'Mission Name',
  patrolStartDate: 'Patrol Start Date',
  pilotName: 'Pilot Name',
  pilotLicenseNumber: 'Pilot License Number',
  receivedDate: 'Received Date',
};

const filter = {
  selectClient: 'Select a client',
};

const finding = {
  exactFindingId: 'Exact Finding Id',
  findingNumber: 'Finding #{{number}}',
  spitfireId: 'Spitfire ID: {{number}}',
  class: 'Class',
  contacted: 'Contacted',
  detectionAt: 'Detection at',
  findings: 'Findings',
  latitude: 'Lat',
  longitude: 'Long',
  sent: 'Sent',
  type: 'Type',
  workZone: 'Work Zone',
  hidePassengerVehicles: 'Hide Regular Passenger Vehicles',
  hideAutomaticallyNotedThreats: 'Hide Automatically Noted Threats',
  irthExternalId: 'IRTH External Id',
};

const message = {
  deletionConfirmation: 'Do you want to delete this patrol?',
  reviewConfirmation: 'Do you want to mark this patrol as reviewed?',
  reviewCompleted: 'Review completed',
  reviewCompletedSuccessfully: 'Patrol review completed successfully',
  published: 'Patrol published',
  pushedToIrth: 'Patrol pushed to IRTH',
  missionPilotNotFound: 'Could not associate uploaded mission to an existing pilot',
};

export default {
  breadcrumb,
  button,
  deleted: 'deleted',
  details,
  filter,
  finding,
  id: 'ID',
  message,
  missionDetails: 'Mission Details',
  table,
  showrow: 'Show ROW',
  hiderow: 'Hide ROW',
};
